/**
 * @namespace Social
 * @aka SWR.Social
 *
 */
SWR.Social = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'social';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '[data-spy="embed"]'
  };

  var Default = {
    type: '',
    url: ''
  };

  var DefaultType = {
    type: 'string',
    url: 'string'
  };

  var nonce = (function () {
    return Date.now();
  }());

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Social = function () {

    function Social(element, config) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
      self._isIntersecting = false;
      self._processing = false;
      self._processed = false;
      self.config = self._getConfig(config);
      self.$preview = self.$element.find('.embed-preview');
      self.$content = self.$element.find('.embed-content');
      self.$footer = self.$element.find('.embed-footer');
      self.url = self.$element.data('url') || '';

      //Facebook-App-Id und Facebook-Access-Token:
      self.fbAppId = '509773232526296';
      self.fbAccessToken = '8173fe635b5eb5ac944976724538f52f';

      self._generatePlaceholder();
      self._addEventHandler();
      self._addIntersectionObserver();
    }

    Social.prototype._addIntersectionObserver = function _addIntersectionObserver() {
      var self = this;
      if (("IntersectionObserver" in window)) {
        var onIntersection = function onIntersection(entries) {
          entries.forEach(function (entry) {
            // entry.isIntersecting is null on some versions of MS Edge
            // entry.intersectionRatio can be 0 on some intersecting elements
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              self._isIntersecting = true;
              self.intersecting();
            } else {
              self._isIntersecting = false;
            }
          });
        };

        self._observer = new IntersectionObserver(onIntersection, {
          root: null,
          rootMargin: '600px'
        });
      }

      if (self._observer) {
        self._observer.observe(self.element);
      } else {
        // Fallback
        self._isIntersecting = true;
        self.intersecting()
      }
    };

    Social.prototype._generatePlaceholder = function _generatePlaceholder() {
      var self = this;
      var $switch = SWR.SocialEmbeds.createSwitch(self.config.embedType, self.config.embedCookie);
      var $switchInfo = SWR.SocialEmbeds.switchInfo(self.config.embedType, self.config.embedCookie);
      var $btn = self.$element.find('[data-spy="embed-load"]');
      var $info = self.$element.find('.small');
      $btn.hide();
      $info.hide();

      if ($switch === -1) {
        $btn.text('Externe Inhalte anzeigen');
        $info.html('Wir stellen die Verbindung zu externen Inhalten erst her, wenn Sie dies erlauben. ' +
          'Mehr dazu finden Sie in unserer <a href="' + window.location.origin + '/datenschutz" target="_blank">Datenschutzerklärung</a>.');
        $btn.show();
        $info.show();
      } else {
        self.$footer.append($switch);
        self.$footer.append($switchInfo);
        self.$footer.show();
        SWR.SocialEmbeds.bindChanges(self.$footer.find('[data-toggle="embedconsent"]').attr('id'));
      }
    };

    Social.prototype._addEventHandler = function _addEventHandler() {
      var self = this;

      $(document).on('swr:embed:load:' + self.config.embedCookie, function () {
        if (!self._isIntersecting) {
          return;
        }
        self.intersecting();
      });

      $(document).on('swr:embed:hide:' + self.config.embedCookie, function () {
        self.hideContent();
      });

      self.$element.on('click', '[data-spy="embed-load"]', function () {
        // Anzeigen des Embeds:
        self.loadContent();

        //Alle Embeds mit diesem Cookie-Type sollen geladen werden:
        $(document).trigger('swr:embed:load:' + self.config.embedCookie);
      });

      self.$element.on('click', '[data-toggle="embedconsent"]', function () {
        if (SWR.SocialEmbeds.getPermission(self.config.embedCookie)) {
          self.hideContent();

          //Alle Embeds mit diesem Cookie-Type sollen verborgen werden:
          $(document).trigger('swr:embed:hide:' + self.config.embedCookie);
        } else {
          // Anzeigen des Embeds:
          self.loadContent();

          //Alle Embeds mit diesem Cookie-Type sollen geladen werden:
          $(document).trigger('swr:embed:load:' + self.config.embedCookie);
        }
      });
    };

    Social.prototype.intersecting = function intersecting(event) {
      var self = this;

      //Wenn entweder in dieser Sitzung, oder in den Datenschutzeinstellungen
      //das Nachladen erlaubt wurde, wird nachgeladen
      if (SWR.SocialEmbeds.getPermission(self.config.embedCookie)) {
        self.loadContent();
      }
    };

    //Verbergen der Embeds:
    Social.prototype.hideContent = function hideContent() {
      var self = this;

      self.$preview.show();
      self.$content.html('').hide();

      self.$element.removeClass('embed-loaded').removeClass('embed-error');
      self._processing = false;
      self._processed = false;
      self.$element.find('[data-toggle="embedconsent"]').prop('checked', false);

      window.setTimeout(function () {
        //Kleine Verzögerung, damit die neue Permission gespeichert wurde.
        var $switchInfo = SWR.SocialEmbeds.switchInfo(self.config.embedType, self.config.embedCookie);
        self.$footer.find('.small').replaceWith($switchInfo);
      }, 100);
    };

    //Nachladen der Embeds:
    Social.prototype.loadContent = function loadContent() {
      var self = this;
      var plattformData = {};

      if (self._observer) {
        self._observer.unobserve(self.element);
        self._observer = null;
      }

      if (self._processing || self._processed) {
        return;
      }

      self._processing = true;
      self.$element.attr({
        'aria-busy': 'true'
      });
      self.$element.addClass('embed-loading');
      self.$element.find('[data-toggle="embedconsent"]').prop('checked', true);

      window.setTimeout(function () {
        //Kleine Verzögerung, damit die neue Permission gespeichert wurde.
        var $switchInfo = SWR.SocialEmbeds.switchInfo(self.config.embedType, self.config.embedCookie);
        self.$footer.find('.small').replaceWith($switchInfo);
      }, 100);

      params = {
        'url': self.url,
        'format': 'json',
        'lang': 'de',
        'dnt': true
      };

      //Für die unterschiedlichen Typen werden der Endpoint und die Parameter festgelegt:
      if ('facebook' === self.config.embedCookie) {
        // Facebook
        plattformData = self._getFacebookParams();
        plattformData.params = $.extend({}, params, plattformData.params);
        console.log(plattformData);

      } else if ('instagram' === self.config.embedCookie) {
        // Instagram
        plattformData = self._getInstagramParams();
        plattformData.params = $.extend({}, params, plattformData.params);
        console.log(plattformData);

      } else if ('twitter' === self.config.embedType) {
        // Twitter
        plattformData = self._getTwitterParams();
        plattformData.params = $.extend({}, params, plattformData.params);
        console.log(plattformData);

      } else if (/^(http(s?)\:)?\/\/((www\.)?)soundcloud\.com\/?/gmi.test(self.url)) {
        // Soundcloud
        plattformData = self._getSoundcloudParams();
        plattformData.params = $.extend({}, params, plattformData.params);
        console.log(plattformData);

      } else if ('spotify-playlist' === self.config.embedType) {
        // Spotify-Playlist
        self._updateSpotify(self);

      } else if ('spotify-audio' === self.config.embedType || 'spotify' === self.config.embedType) {
        // Spotify

        /*
        NOT WORKING (CORS)
        plattformData = self._getSpotifyParams();
        plattformData.params = $.extend({}, params, plattformData.params);
        console.log(plattformData);
        */

        //Alternative:
        self._spotifyAlternative();
        return;

      } else if ('apester' === self.config.embedCookie) {
        // Apester
        plattformData = self._getApesterParams();
        plattformData.params = $.extend({}, params, plattformData.params);
        console.log(plattformData);

      } else if ('tiktok' === self.config.embedCookie) {
        // TikTok
        plattformData = self._getTikTokParams();
        plattformData.params = $.extend({}, params, plattformData.params);
        console.log(plattformData);

      } else if ('vimeo' === self.config.embedType) {
        // vimeo
        self._loadVimeo();
        return;

      } else if ('youtube' === self.config.embedType) {
        //} else if (/(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})?/gmi.test(self.url)) {
        // YouTube
        self._loadYouTube();
        return;

      } else if ('timeline' === self.config.embedType) {
        //Timeline
        self._updateTimeline();
        return;

      } else if ('giphy' === self.config.embedCookie) {
        // Giphy
        self._loadGiphy();
        return;

      } else if ('twitch' === self.config.embedCookie) {
        // Twitch
        self._loadTwitch();
        return;
      } else if ('mastodon' === self.config.embedType) {
        // Mastodon
        self.loadSDK(self.config.embedType);
        self._loadMastodon(EVENT_KEY, DATA_API_KEY);
        return;
      } else {
        //Falls der Type des Embeds nicht den implementierten Typen entspricht, wird ein Fehlerhinweis angezeigt:
        self._failed(self.config.embedCookie, self.url);
        console.log('invalid oEmbed', self.url, self.config.embedType);
        return;
      }

      //Aufruf der oembed-API
      console.log(plattformData.endpoint, plattformData.params, plattformData.dataType);

      $.ajax({
        url: plattformData.endpoint,
        data: plattformData.params,
        dataType: plattformData.dataType,
        cache: true,
        crossDomain: true,
        jsonpCallback: function () {
          var callback = (jQuery.expando.toLowerCase() + '' + (nonce++));
          this[callback] = true;
          return callback;
        }
      }).done(function (data) {
        //Im Erfolgsfall wird der Contentbereich angezeigt:
        self._done(data.html);

        //Falls erforderlich wird noch die entsprechende SDK nachgeladen:
        self.loadSDK(self.config.embedCookie);
      }).fail(function (xhr, status, err) {
        console.log(xhr, status, err);
        //Im Fehlerfall wird anstelle des Embeds ein Hinweis mit Link angezeigt:
        self._failed(self.config.embedCookie, self.url);
      });
    };

    // public
    Social.prototype.dispose = function dispose() {
      if (this._observer) {
        this._observer.unobserve(this.element);
        this._observer = null;
      }

      $(this.element).off(EVENT_KEY);
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // private
    Social.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);

      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    // static
    Social._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Default, $(this).data());

        if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
          $.extend(_config, config);
        }

        if (!data) {
          data = new Social(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof action === "string") {
          if (data[action] === undefined) {
            throw new Error('No method named "' + action + '"');
          }
          data[action]();
        }
      });
    };

    return Social;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $embed = $(this);
    Social._jQueryInterface.call($embed, $embed.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $embed = $(this);
      Social._jQueryInterface.call($embed, $embed.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Social._jQueryInterface;
  $.fn[NAME].Constructor = Social;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Social._jQueryInterface;
  };

  return Social;

})(window.jQuery);

/**
 * swr-iframe durch iframe ersetzen:
 */
(function ($) {

  function updateIframe() {
    $('swr-iframe').each(function () {
      var attrs = {};

      $.each(this.attributes, function (idx, attr) {
        attrs[attr.nodeName] = attr.nodeValue;
      });

      var $iframe = $('<iframe />', attrs).append($(this).contents());
      $(this).replaceWith($iframe);
    });
  }

  $(document).on('pjax:end', function () {
    updateIframe();
  });
  updateIframe();

})(window.jQuery);
